import styled from 'styled-components'

export const Copyright = () => {
  return <Footer>© {new Date().getFullYear()}, Outbound AI. All Rights Reserved.</Footer>
}

const Footer = styled.footer`
  height: 2.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.s.normal};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
`
